import angular from 'angular';

angular.module('neurotecAbisWebClientApp')
	.directive('minutiaAdjustment', () => ({
		template: require('../../../views/directives/latent-editor/minutia-adjustment.html'),
		restrict: 'E',
		replace: true,
		scope: {
			changemode: '=',
			minutiacontrol: '='
		}
	}));
